<template>
  <v-link
    v-bind="{ ...props, ...$attrs }"
    ref="link"
    :class="[
      decorationClass(active),
    ]"
  >
    <template
      v-for="(slot, index) of Object.keys($slots)"
      :key="index"
      #[slot]="scope"
    >
      <slot
        :name="slot"
        v-bind="scope || {}"
      />
    </template>
  </v-link>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

defineOptions({
  inheritAttrs: false,
})

const {
  ...props
} = defineProps({
  color: {
    type: String as PropType<string>,
  },
  active: {
    type: Boolean as PropType<boolean>,
  },
  inline: Boolean as PropType<boolean>,
})

const linkRef = useTemplateRef('link')
const isHovered = useElementHover(linkRef)

function decorationClass(active?: boolean) {
  if (active) {
    return isHovered.value ? 'decoration-transparent' : 'decoration-current'
  }
  else {
    return isHovered.value ? 'decoration-current' : 'decoration-transparent'
  }
}
</script>
